import type { IconName } from '@/components/atoms/icon';

export type QueueStatusPresentation = {
  icon: IconName;
  blurb: string;
};

export const QUEUE_STATUS_PRESENTATION: Record<string, QueueStatusPresentation> = {
  focus: {
    icon: 'flame',
    blurb: 'In active rotation right now.',
  },
  maintenance: {
    icon: 'clock',
    blurb: 'Already learned. Keep it warm.',
  },
  normal: {
    icon: 'pause',
    blurb: 'On the list, not on the queue.',
  },
};
